module.exports = __webpack_public_path__ + "granuli_pe@2x.jpg?cab542ce77551367988390764ff27145";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/granuli_pe@2x.jpg
// module id = 195
// module chunks = 0